import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import "./modal.css";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import ErrorMsg from "../form/errorMsg";
import { useDispatch } from "react-redux";
import { updateOrderStatus } from "../../redux/actions/orderActions";
import ErrorPopup from "../Popups/ErrorPopup";
import SuccessPopup from '../../components/Popups/SuccessPopUp';

const UpdateStatusModal = ({ updateShow, handleClose, id, selectedOrderStatus, fetchOrderList }) => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState('');

  useEffect(() => {
    console.log("selectedOrderStatus", selectedOrderStatus);
  }, [selectedOrderStatus])
  // const options = () => {
  //   return [
  //     { value: "cancelled", label: "Cancel" },
  //     { value: "delivered", label: "Delivered" },
  //     { value: "out_for_delivery", label: "Out For Delivery" },
  //     { value: "partial_completed", label: "Partial Completed" },
  //     { value: "invoiced", label: "Invoiced" },
  //     { value: "rejected", label: "Reject" },
  //   ];
  // };

  const initialValues = {
    status: "",
    description: "",
  };
  const validationSchema = Yup.object().shape({
    status: Yup.string().required("Required"),
    description: Yup.string(),
  });
  const onSubmit = (values) => {
    values["order_id"] = id;
    console.log(values);
    dispatch(updateOrderStatus(values, onSuccess, onError));
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    handleClose();
    fetchOrderList();
  }
  const onSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const message = (data.data.message);
    const msg_updated = message.charAt(0).toUpperCase() + message.slice(1);
    setShowSuccessMsg(msg_updated);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false)
  }

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true)
    const str = (err.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <div className="px-5 mx-5">
      <Modal
        centered
        show={updateShow}
        id={id}
        dialogClassName="update-status-container col-8 px-3 mx-auto"
        contentClassName="update-status-container "
      >
        <ModalHeader>
          <span className="fn_Nunito fw_600 fs_14 Medium_Purple text-uppercase px-2 pt-2">
            Update Status
          </span>
        </ModalHeader>
        <ModalBody>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ setFieldValue, values }) => (
              <Form>
                <div className="px-2 pb-2">
                  <div className="mt-2">
                    <span className="fn_Nunito fw_600 fs_14 color_262c3d">
                      Order Status
                    </span>
                    <div className="mt-1">
                      <Select
                        options={options}
                        styles={customStyles}
                        placeholder={"Select order status"}
                        onChange={(e) => setFieldValue("status", e.value)}
                      />
                      <ErrorMsg name="status" />
                    </div>
                  </div>
                  <div className="my-3">
                    <span className="fn_Nunito fw_600 fs_14 color_262c3d">
                      Description
                    </span>
                    <Field
                      as="textarea"
                      rows="5"
                      className="modal-text-area w-100 mt-1 p-2"
                      placeholder="Write a discription of order status(Optional)"
                      name="description"
                      id="description"
                    />
                    <ErrorMsg name="description" />
                  </div>
                  <div className="d-flex justify-content-end  me-2 gap-2">
                    <button
                      className="modal-close-btn px-4 py-1 fs_12"
                      type="button"
                      onClick={() => handleClose()}
                    >
                      <span className="mx-3"> close</span>
                    </button>
                    <div>
                      <button
                        className="modal-submit-btn text-white px-4 py-2 fs_12"
                        type="submit"
                      >
                        <span className="px- fw_600 mx-3">Update</span>
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
          <SuccessPopup
            show={showSuccessPopup}
            title={showSuccessMsg}
          />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default UpdateStatusModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,

    border: " 1px solid #B0B3C7",
  }),
  control: (base, state) => ({
    ...base,
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",

    borderRadius: "5px",
    width: "100%",

    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
